import ListProcesses from "@/views/agro_exporter/quality_reports/process/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/quality_reports/process/ShowProcess.vue";
import ShowProcessSummary from "@/components/views/agro_exporter/quality_reports/process/show_process/Summary.vue";
import ShowProcessWeekly from "@/components/views/agro_exporter/quality_reports/process/show_process/Weekly.vue";
import ShowProcessQuarterly from "@/components/views/agro_exporter/quality_reports/process/show_process/Quarterly.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_reports",
  permission: "process",
});


export default [
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
    redirect: { name: routeName("show_process_summary") },
    children: [
    {
        path: "summary",
        name: routeName("show_process_summary"),
        alias: "",
        component: ShowProcessSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_process_weekly"),
        alias: "",
        component: ShowProcessWeekly,
        props: true
      },
      {
        path: "quarterly",
        name: routeName("show_process_quarterly"),
        component: ShowProcessQuarterly,
        props: true
      },
    ],
  },
];
